import { FC, memo } from 'react'
import Box from '@mui/material/Box'
import Table from '@mui/material/Table'
import TableBody from '@mui/material/TableBody'
import TableCell from '@mui/material/TableCell'
import TableContainer from '@mui/material/TableContainer'
import TableHead from '@mui/material/TableHead'
import TableRow from '@mui/material/TableRow'
import { useCompanyPaymentsPreview } from '../../../providers/CompanyPaymentsProvider'
import CompanyPaymentsTableRow from '../../companyPayments/CompanyPaymentsTable/CompanyPaymentsTableRow'
import { Typography } from '@mui/material'

const CompanyPaymentsPanel: FC = () => {
  const { companyPayments, status } = useCompanyPaymentsPreview()
  return (
    <Box
      sx={theme => ({
        marginBottom: 2,
        display: 'flex',
        flexDirection: 'column',
        gap: 2,
        border: `1px solid ${theme.palette.divider}`,
        borderRadius: 1,
      })}
    >
      {status === 'empty' && (
        <Box sx={{ height: 56 }}>
          <Typography>No payment methods found</Typography>
        </Box>
      )}
      <TableContainer component={'div'}>
        <Table aria-label="simple table">
          <TableHead>
            <TableRow>
              <TableCell size="small">Date</TableCell>
              <TableCell align="left">Credits purchased</TableCell>
              <TableCell align="right">Amount paid</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {companyPayments.map(companyPayment => {
              return (
                <CompanyPaymentsTableRow key={companyPayment.id} companyPayment={companyPayment} />
              )
            })}
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  )
}

export default memo(CompanyPaymentsPanel)
